import React from 'react';
import { useTranslation } from '../../../../../core';
import { DetailsSection } from '../DetailsSection';
import { IntegrationDetailsFields } from '../IntegrationDetailsFields';
import { IntegrationDetailsFooter } from '../IntegrationDetailsFooter';

/**
 * Renders SMTP and protocol settings.
 *
 * @param {object} props
 * @param {Array<object>} props.fields
 * @param {boolean} props.hasChanges
 * @param {object} props.integration
 * @param {boolean} props.isSaving
 * @param {Function|null} props.onClose
 * @param {Function|null} props.onSave
 * @param {object} props.updatedData
 */
export const SmtpTab = ({
    fields = [],
    hasChanges = false,
    integration,
    isSaving = false,
    onClose = null,
    onSave = null,
    updatedData
}) => {
    const { t } = useTranslation();

    return (
        <div>
            <DetailsSection title={t('integrations.smtpSettings')}>
                <IntegrationDetailsFields
                    fields={fields}
                    integration={integration}
                    isSingleColumn={true}
                    updatedData={updatedData}
                />
            </DetailsSection>
            <IntegrationDetailsFooter
                hasUpdated={hasChanges}
                isSaving={isSaving}
                onClose={onClose}
                onSave={onSave}
            />
        </div>
    );
};
